// Pojistka „Počítám…" (20. 10. 2026): když hodnocení tipů nestíhá (Vertex vrací
// 429 ve všech oblastech), server odpoví 503 s `unavailable` a tip se
// nezapočítá. Místo chyby to zkusíme znovu se stejným tipem, s rostoucí pauzou,
// celkem asi minutu — hráč vidí „Počítám…", ne „zkus to za chvíli". Funguje přes
// všechny instance: opakování je obyčejný nový požadavek.

export const SCORING_RETRY_DELAYS_MS = [2000, 3000, 5000, 8000, 12000, 15000, 15000];

const defaultSleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// `doFetch` vrací Promise<Response>. Vrátí poslední odpověď: úspěch, jinou
// chybu, nebo 503 po vyčerpání pokusů. `onPending(true)` se zavolá před první
// pauzou; vypnout ho je na volajícím (finally).
export async function fetchScoring(doFetch, { onPending, sleep = defaultSleep, delays = SCORING_RETRY_DELAYS_MS } = {}) {
  for (let i = 0; ; i++) {
    const response = await doFetch();
    if (response.status !== 503 || i >= delays.length) return response;
    let body = null;
    try {
      body = await response.clone().json();
    } catch (e) {
      body = null;
    }
    if (!body || !body.unavailable) return response;
    if (onPending) onPending(true);
    await sleep(delays[i]);
  }
}
